module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button-component', {
    staticClass: "ViewerButton",
    class: _vm.buttonClasses,
    attrs: {
      "icon": _vm.icon,
      "dark": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96f4d9ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewerButton.vue
// module id = 789
// module chunks = 1474